import { useState, useEffect } from "react";
import { useWidgetStore } from "@/stores/widget-store";
import { dismissBanner } from "@/services/widget";

export const useBannerVisibility = (bannerId: string) => {
    const banners = useWidgetStore((state) => state.config.banners || {});
    const fetchConfig = useWidgetStore((state) => state.fetchConfig);

    const checkVisibility = () => {
        const bannerData = banners[bannerId];

        // If no data exists yet, show the banner
        if (!bannerData) {
            return true;
        }

        // Return the status directly (true = show, false = hide)
        return bannerData.status;
    };

    const [isVisible, setIsVisible] = useState(checkVisibility());

    useEffect(() => {
        setIsVisible(checkVisibility());
    }, [banners, bannerId]);

    const hide = async () => {
        try {
            await dismissBanner(bannerId);
            setIsVisible(false);
            // Refresh config to update the banners list
            await fetchConfig();
        } catch (error) {
            console.error("Failed to dismiss banner:", error);
        }
    };

    return {
        isVisible,
        hide,
    };
};
